import { render, staticRenderFns } from "./formModal.vue?vue&type=template&id=d6b0ef02&scoped=true&"
import script from "./formModal.vue?vue&type=script&lang=js&"
export * from "./formModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b0ef02",
  null
  
)

export default component.exports